/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Select from "react-select";
import { selectStyles } from "../../utils/selectStyel";

// keep this hook only for fetching individual model config by ID
const useModelConfig = (modelId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!modelId) return;
    const fetchConfig = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `/api/model?id=${encodeURIComponent(modelId)}`,
        );
        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const result = await response.json();
        setData(result);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchConfig();
  }, [modelId]);

  return { data, loading, error };
};

// models prop now comes from parent — no internal fetch needed
const SearchModelList = ({
  setSchema,
  models,
  selectedModel,
  setSelectedModel,
}) => {
  const groupOptions = [{ value: "EDSS", label: "EDSS" }];
  const [selectedGroup, setSelectedGroup] = useState(groupOptions[0].value);

  useEffect(() => {
    setSelectedModel(null);
  }, [selectedGroup]);

  const modelOptions =
    selectedGroup && models[selectedGroup]
      ? models[selectedGroup].map((m) => ({
          value: m.CONFIG_ID,
          label: m.Name,
        }))
      : [];

  const {
    data,
    loading: configLoading,
    error: configError,
  } = useModelConfig(selectedModel?.value);

  useEffect(() => {
    if (data) setSchema(data);
  }, [data]);

  return (
    <Box px={5}>
      <Text fontSize="md" mb={4}>
        Select a model
      </Text>
      <Flex align="center" gap={4} flexDir={{ base: "column", md: "row" }}>
        <Box w={{ base: "full", md: "md" }}>
          <Select
            options={groupOptions}
            value={groupOptions.find((opt) => opt.value === selectedGroup)}
            onChange={(option) => setSelectedGroup(option.value)}
            placeholder="Select Group"
          />
        </Box>
        {selectedGroup && (
          <Box w={{ base: "full", md: "md" }}>
            <Select
              options={modelOptions}
              value={selectedModel}
              onChange={(option) => setSelectedModel(option)}
              placeholder="Select Model"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={selectStyles}
            />
          </Box>
        )}
      </Flex>
      <Box mt={5}>
        {configLoading && <Spinner />}
        {configError && <Text color="red.500">Error loading config</Text>}
      </Box>
    </Box>
  );
};

export default SearchModelList;
